import TireRotationWhite from 'components/common/Icon/assets/tire-rotation-white.svg'
import OilChangeWhite from 'components/common/Icon/assets/oil-change-white.svg'
import TipsAndResources from 'components/common/Icon/assets/tips-and-resources.svg'
import Mileage from 'components/common/Icon/assets/mileage.svg'

export const generateSliderImg = iconName => {
  const images = {
    'tips-and-resources': TipsAndResources,
    'oil-change-white': OilChangeWhite,
    'tire-rotation-white': TireRotationWhite,
    mileage: Mileage
  }

  return images[iconName]
}
